import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../sliderreusable/slider-reusable.css";

export default function FeatureEvent() {

  const hasFetched = useRef(false);
  const [featureEvent, setFeatureEvent] = useState();
  // const [autoPlay, setAutoPlay] = useState(true);
  const navigate = useNavigate();
  const length = featureEvent?.featureVenetData?.length || 0;

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 1000,
    infinite: length > 1,
    autoplaySpeed: 2000,
    autoplay: length > 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  const featureMatch = () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/featureEvent`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        setFeatureEvent(paresData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  

//   useEffect(() => {
//   const length = featureEvent?.featureVenetData?.length || 0;

//   if (length > 1) {
//     setAutoPlay(true);   // multiple → autoplay ON
//   } else {
//     setAutoPlay(false);  // 0 or 1 → autoplay OFF
//   }
// }, [featureEvent]);
  

   useEffect(() => {
    if (!hasFetched.current) {
      featureMatch();
      hasFetched.current = true;
    }
  }, []);

  const getIcon = (sportId) => {
    if (sportId == "4") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M23.4267 4.57333C20.912 2.14456 17.544 0.80063 14.048 0.831009C10.5521 0.861388 7.20792 2.26364 4.73581 4.73575C2.2637 7.20786 0.861449 10.552 0.83107 14.048C0.800692 17.5439 2.14462 20.912 4.57339 23.4267C7.08809 25.8554 10.4561 27.1994 13.9521 27.169C17.448 27.1386 20.7922 25.7364 23.2643 23.2642C25.7364 20.7921 27.1387 17.448 27.169 13.952C27.1994 10.4561 25.8555 7.08803 23.4267 4.57333ZM6.45339 6.45333C7.95564 4.95046 9.87253 3.93052 11.9583 3.5243C14.044 3.11807 16.2036 3.34408 18.1601 4.17333L17.7734 4.57333L18.7201 5.52L19.4134 4.81333C19.8 5.04659 20.1738 5.30028 20.5334 5.57333L5.57339 20.5333C5.30034 20.1738 5.04665 19.7999 4.81339 19.4133L5.52006 18.72L4.57339 17.7733L4.18672 18.16C3.35581 16.2048 3.12765 14.046 3.53148 11.9604C3.93532 9.87467 4.95275 7.95708 6.45339 6.45333ZM21.5467 21.5467C20.0445 23.0495 18.1276 24.0695 16.0418 24.4757C13.9561 24.8819 11.7965 24.6559 9.84006 23.8267L10.2267 23.4267L9.28006 22.48L8.58672 23.1867C8.20015 22.9534 7.82629 22.6997 7.46672 22.4267L22.4267 7.46666C22.6998 7.82623 22.9535 8.20009 23.1867 8.58666L22.4801 9.28L23.4267 10.2267L23.8134 9.84C24.6443 11.7952 24.8725 13.9539 24.4686 16.0396C24.0648 18.1253 23.0474 20.0429 21.5467 21.5467ZM13.0534 18.72L14.0001 19.6533L12.1201 21.5467L11.1734 20.6667L13.0534 18.72ZM16.8267 14.9467L17.7734 15.88L15.8801 17.7733L14.9467 16.8267L16.8267 14.9467ZM20.6667 11.1733L21.6134 12.12L19.6534 14L18.7201 13.0533L20.6667 11.1733ZM14.9467 9.28L14.0001 8.34666L15.8801 6.45333L16.8267 7.4L14.9467 9.28ZM11.1734 13.0533L10.2267 12.12L12.1201 10.2267L13.0534 11.1733L11.1734 13.0533ZM7.40006 16.8267L6.45339 15.88L8.34672 14L9.28006 14.9467L7.40006 16.8267Z"
            fill="#ffffff"
          ></path>
        </svg>
      );
    } else if (sportId == "1") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <path
            d="M13 0C16.4478 0 19.7544 1.36964 22.1924 3.80761C24.6304 6.24558 26 9.55219 26 13C26 16.4478 24.6304 19.7544 22.1924 22.1924C19.7544 24.6304 16.4478 26 13 26C9.55219 26 6.24558 24.6304 3.80761 22.1924C1.36964 19.7544 0 16.4478 0 13C0 9.55219 1.36964 6.24558 3.80761 3.80761C6.24558 1.36964 9.55219 0 13 0ZM10.672 2.246L13 3.8L15.328 2.248C13.7936 1.91713 12.2064 1.91713 10.672 2.248V2.246ZM8.286 3.058C6.82673 3.75245 5.53773 4.7588 4.51 6.006L5.804 10.214L7.816 10.884L12 7.704V5.536L8.286 3.058ZM3.096 8.21C2.54312 9.34949 2.19256 10.5764 2.06 11.836L3.83 10.598L3.096 8.21ZM2.072 14.27C2.272 16 2.872 17.61 3.778 19H7.586L8.856 17.73L7.21 12.79L5.162 12.108L2.072 14.268V14.27ZM5.452 21C6.258 21.764 7.182 22.406 8.192 22.896L7.354 21H5.454H5.452ZM10.772 23.774C12.2419 24.0765 13.7581 24.0765 15.228 23.774L16.808 20.222L15.586 19H10.414L9.194 20.22L10.772 23.774ZM17.806 22.896C18.8115 22.4068 19.7368 21.7675 20.55 21H18.65L17.806 22.896ZM22.22 19C23.1 17.652 23.692 16.1 23.908 14.43L20.82 12.114L18.79 12.79L17.144 17.73L18.414 19H22.22ZM23.952 11.964C23.8302 10.649 23.4711 9.36692 22.892 8.18L22.158 10.62L23.952 11.964ZM21.464 5.974C20.4404 4.7414 19.1608 3.74637 17.714 3.058L14 5.536V7.704L18.184 10.884L20.192 10.216L21.464 5.974ZM9.176 12.36L10.72 17H15.28L16.824 12.362L13 9.456L9.176 12.364V12.36Z"
            fill="#ffffff"
          ></path>
        </svg>
      );
    } else if (sportId == "2") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.428 23.428C28.6347 18.2213 28.6347 9.77866 23.428 4.57199C18.2213 -0.634674 9.77866 -0.634674 4.57199 4.57199C-0.634674 9.77866 -0.634674 18.2213 4.57199 23.428C9.77866 28.6347 18.2213 28.6347 23.428 23.428ZM24.5907 12.7213C24.3078 10.35 23.234 8.1433 21.5427 6.45733C19.8505 4.75994 17.6339 3.6848 15.2533 3.40666L15.24 3.48133C14.6987 6.40036 13.2852 9.08673 11.186 11.186C9.08673 13.2852 6.40036 14.6987 3.48133 15.24L3.40666 15.2533C3.6848 17.6339 4.75994 19.8505 6.45733 21.5427C8.1433 23.234 10.35 24.3078 12.7213 24.5907L12.7373 24.4973C13.2783 21.578 14.6917 18.8914 16.791 16.7919C18.8903 14.6924 21.5768 13.2787 24.496 12.7373L24.5893 12.7213H24.5907ZM24.496 15.9053V15.46C22.2925 15.9639 20.2757 17.079 18.6774 18.6774C17.079 20.2757 15.9639 22.2925 15.46 24.496H15.9053C18.0422 24.111 20.0097 23.0803 21.5427 21.5427C23.0804 20.0097 24.1111 18.0422 24.496 15.9053ZM3.48266 12.5187V12.2213C3.84868 10.0367 4.88879 8.02133 6.45733 6.45733C8.0212 4.88837 10.0366 3.8478 12.2213 3.48133H12.5173C12.0134 5.68485 10.8983 7.70158 9.29993 9.29993C7.70158 10.8983 5.68485 12.0134 3.48133 12.5173L3.48266 12.5187Z"
            fill="#ffffff"
          ></path>
        </svg>
      );
    } else if (sportId == "500") {
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M20.498 15.5H3.5V20.5H20.498V15.5ZM21.9445 14.4719L21.9661 14.5336L21.9892 14.6345L21.9981 14.7331V21.25C21.9981 21.6297 21.7159 21.9435 21.3499 21.9932L21.2481 22H2.75C2.3703 22 2.05651 21.7178 2.00685 21.3518L2 21.25V14.7506L2.00184 14.6977L2.01271 14.6122C2.02285 14.5584 2.03841 14.5072 2.05894 14.4587L4.81824 8.44003C4.92517 8.2068 5.14245 8.04682 5.39153 8.01047L5.5 8.0026L8.03982 8.00183L7.25089 9.37206L7.18282 9.50183L5.981 9.502L3.918 13.9998H20.07L18.0428 9.65383L18.9052 8.15653C18.9718 8.20739 19.0301 8.26957 19.0771 8.3411L19.1297 8.43553L21.9445 14.4719ZM13.3652 2.05565L13.4566 2.10062L18.6447 5.10375C18.9729 5.29371 19.1033 5.69521 18.9636 6.03728L18.9187 6.1289L16.112 11.001L17.25 11.0016C17.6642 11.0016 18 11.3374 18 11.7516C18 12.1313 17.7178 12.4451 17.3518 12.4948L17.25 12.5016L15.248 12.501L15.2471 12.504H11.1691L11.166 12.501L6.75 12.5016C6.33579 12.5016 6 12.1658 6 11.7516C6 11.3719 6.28215 11.0581 6.64823 11.0085L6.75 11.0016L8.573 11.001L8.39145 10.8963C8.06327 10.7063 7.93285 10.3048 8.0726 9.96272L8.11747 9.8711L12.4341 2.37536C12.6235 2.04633 13.024 1.91557 13.3652 2.05565ZM13.3559 3.77529L9.78781 9.97119L11.566 11.001H14.383L17.248 6.02818L13.3559 3.77529Z"
              fill="#ffffff"
            ></path>{" "}
          </g>
        </svg>
      );
    } else if (sportId == "400") {
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 475 475"
          fill="#ffffff"
        >
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M0,105v4.9V370h475V105H0z M242.6,115.1h222.3v45H242.6V115.1z M412.4,169.8v134.9H385V169.8H412.4z M374.9,169.8v134.9 H242.6V169.8H374.9z M232.4,359.9H10.1v-45h222.3V359.9z M10.1,304.7V169.8h42.4v134.9H10.1z M62.6,304.7V169.8H90v134.9H62.6z M232.4,304.7H100.1V169.8h132.3V304.7z M232.4,160.1H10.1v-45h222.3V160.1z M464.9,359.9H242.6v-45h222.3V359.9z M464.9,304.7 h-42.4V169.8h42.4V304.7z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </svg>
      );
    } else if (sportId == "7") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30.017"
          height="26.717"
          viewBox="0 0 30.017 26.717"
        >
          <g
            id="Horse_Racing-01-01"
            data-name="Horse Racing-01-01"
            transform="translate(-49.968 -71.978)"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M55.6,84.259a1.759,1.759,0,0,0-1.592.015c-.463.239-.919.495-1.393.709a2.476,2.476,0,0,1-2.224-.066.625.625,0,0,1-.265-1A17.245,17.245,0,0,1,51.5,82.25a2.97,2.97,0,0,1,4.375-.239,5.155,5.155,0,0,1,1,1.087c.053.075.084.181.225.111a5.487,5.487,0,0,1,2.927-.35c.119.009.236.012.355.016a.45.45,0,0,0,.095-.031c-.375-.255-.735-.49-1.086-.732a3.156,3.156,0,0,1,.588-5.566q2.436-1.018,4.878-2.018a6.071,6.071,0,0,1,1.811-.6,3.152,3.152,0,0,1,1.689.317c.15.075.225.119.3-.1a3.145,3.145,0,1,1,2.206,4.047l-.225-.05c.146.45.288.864.414,1.285.069.229.194.093.291.055a8.832,8.832,0,0,1,3.578-.655,5.825,5.825,0,0,1,4.663,2.222l.018.023c.54.7.525.876-.127,1.477-.283.26-.564.525-.851.779a.245.245,0,0,0-.094.3,46.563,46.563,0,0,1,1.138,5.005.608.608,0,0,1-.207.587q-.311.295-.632.58a.62.62,0,0,1-.685.129c-.611-.246-1.225-.487-1.833-.738A.583.583,0,0,1,75.9,88.6c.008-.167-.075-.218-.2-.271a5.362,5.362,0,0,1-1.126-.642,2.613,2.613,0,0,1-.81-.963.68.68,0,0,0-.086-.154c-.313-.375-.446-.386-.825-.075a5,5,0,0,0-1.215,1.547c-.1.185-.052.242.14.288,1.139.27,2.276.552,3.413.829a.653.653,0,0,1,.5,1.018q-1.325,2.851-2.653,5.7a.94.94,0,0,1-.39.428c-1.01.593-2.017,1.192-3.028,1.783a.629.629,0,0,1-1.025-.479c-.164-.991-.314-1.985-.456-2.979a.622.622,0,0,1,.606-.8q.779-.122,1.552-.235a.393.393,0,0,0,.348-.26c.2-.459.418-.912.636-1.363.066-.137.075-.193-.113-.212a28.181,28.181,0,0,1-2.868-.4.518.518,0,0,0-.262.014,13.377,13.377,0,0,1-4.829.467,3.458,3.458,0,0,0-.413-.014c-.089,0-.225-.071-.256.055-.026.108.118.139.2.19a15.516,15.516,0,0,0,1.52.966,3.37,3.37,0,0,1,1.853,2.283c.222.822.59,1.605.89,2.406.23.615-.069,1.025-.726.963-1.1-.1-2.2-.225-3.293-.346a.624.624,0,0,1-.594-.782c.046-.422.083-.844.137-1.264a.341.341,0,0,0-.2-.4c-1.095-.623-2.176-1.266-3.272-1.892a.775.775,0,0,1-.438-.766c.018-.413-.015-.83.011-1.243.017-.265-.05-.359-.326-.4a4.424,4.424,0,0,1-3.721-3.452,4.225,4.225,0,0,1,.855-3.641C55.488,84.427,55.576,84.371,55.6,84.259ZM66.929,75.18a2.027,2.027,0,0,0-.87.212c-1.835.762-3.668,1.528-5.506,2.28a1.916,1.916,0,0,0-.342,3.477c1.159.764,2.31,1.541,3.466,2.313.792.529.785.525.594,1.469q-.425,2.084-.83,4.171a.63.63,0,0,0,.771.759c.338-.086.441-.356.5-.663q.51-2.609,1.028-5.216c.1-.489.039-.634-.382-.916L61.5,80.489a.65.65,0,0,1-.264-.933.642.642,0,0,1,.959-.119q.693.455,1.377.918a.268.268,0,0,0,.292.05q1.464-.621,2.939-1.222c.126-.051.157-.1.109-.236-.156-.445-.3-.9-.439-1.346a.624.624,0,0,1,.375-.816.632.632,0,0,1,.821.424c.028.075.047.15.075.225l1.767,5.382a.858.858,0,0,0,.28.473.626.626,0,0,0,.745,0,.666.666,0,0,0,.191-.825q-.985-3-1.974-6A1.858,1.858,0,0,0,66.929,75.18ZM62.663,86.51c.119-.582.22-1.082.322-1.583a.545.545,0,0,0-.541-.693c-1.2-.062-2.4-.157-3.606-.15a3,3,0,0,0-2.752,1.742,2.915,2.915,0,0,0,.215,3.161A3.2,3.2,0,0,0,59.108,90.4c.555,0,.766.225.768.777,0,.525.011,1.047-.006,1.569a.4.4,0,0,0,.243.413c1.093.627,2.19,1.249,3.264,1.907a3.974,3.974,0,0,0,1.357.3c-.15-.606-.15-.606-.6-.9l-2.585-1.661a.648.648,0,0,1-.332-.825c.17-.718.347-1.435.513-2.154A3.989,3.989,0,0,0,61.87,87.9a5.5,5.5,0,0,0-.651-1.351.624.624,0,0,1,.2-.876.631.631,0,0,1,.873.229c.113.185.218.368.365.609Zm3.568,1.514c.1.017.112-.065.15-.117a.94.94,0,0,1,.461-.4.636.636,0,0,1,.7.248.623.623,0,0,1-.065.79.881.881,0,0,0,.484,1.44,11.233,11.233,0,0,0,1.156.239c1.081.177,2.172.26,3.256.4a.6.6,0,0,1,.505.87,32.014,32.014,0,0,1-1.5,3.1.225.225,0,0,0-.027.167c.038.241.075.482.122.74a.973.973,0,0,0,.6-.54c.162-.411.371-.8.558-1.2.543-1.167,1.087-2.334,1.637-3.519-.11-.031-.2-.059-.3-.082l-3.9-.953a.646.646,0,0,1-.567-.71.616.616,0,0,1,.683-.549c.095,0,.137-.017.173-.1A5.833,5.833,0,0,1,72.182,85.4c-.352-.274-.7-.537-1.035-.807a.233.233,0,0,0-.263-.046,1.828,1.828,0,0,1-2.123-.5.28.28,0,0,0-.311-.082c-.393.087-.787.179-1.185.24a.355.355,0,0,0-.353.332c-.221,1.165-.456,2.328-.685,3.492Zm8.352-5.788a9.17,9.17,0,0,0-1.885.325c-.41.1-.744.215-.707.725a.158.158,0,0,1-.024.084c-.083.15-.037.243.1.342.375.275.742.554,1.095.853a.759.759,0,0,0,.667.193c.657-.1.943.15.942.815a.462.462,0,0,0,.215.412c.627.476,1.244.966,1.867,1.448.143.111.314.232.3.416-.029.348.2.411.444.5.166.059.329.129.491.2.189.083.292.05.244-.179-.29-1.385-.5-2.789-.927-4.143A2.547,2.547,0,0,0,74.583,82.236Zm-2.945-5.211a1.893,1.893,0,1,0-1.9-1.893,1.893,1.893,0,0,0,1.9,1.893Zm2.883,3.059a7.4,7.4,0,0,0-2.551.515c-.478.177-.465.176-.321.666.064.218.14.267.365.193a8.182,8.182,0,0,1,3.017-.472,3.8,3.8,0,0,1,2.476.976c.361.336.359.338.72.012.3-.27.3-.272.008-.565A4.922,4.922,0,0,0,74.521,80.084ZM65,81.3a17.681,17.681,0,0,1,1.52,1.1c.085.085.142.013.2-.03.31-.225.616-.457.927-.681a.194.194,0,0,0,.075-.251c-.111-.325-.218-.652-.324-.976-.027-.081-.049-.14-.161-.092C66.5,80.676,65.76,80.985,65,81.3Zm-13.3,2.649a4.1,4.1,0,0,0,1.258-.546,4.141,4.141,0,0,1,1.5-.574c.061-.007.15.036.174-.057s-.082-.123-.15-.155a1.486,1.486,0,0,0-1.544.057A5.692,5.692,0,0,0,51.706,83.946Zm13.779,13.4c-.21-.684-.21-.682-.861-.727-.15-.011-.293-.032-.44-.048-.437-.047-.478,0-.478.435,0,.111.023.158.139.17C64.382,97.225,64.919,97.284,65.485,97.343Zm4.22-.8c.587-.264.588-.264.513-.837-.017-.126-.041-.251-.058-.375-.056-.434-.055-.425-.474-.375-.167.02-.217.07-.188.238C69.575,95.634,69.636,96.08,69.705,96.543Zm-3.718-7.235a2.413,2.413,0,0,1-.579,1.272l1.042-.133A2.735,2.735,0,0,1,65.987,89.308Z"
              transform="translate(0 0)"
              fill="#ffffff"
            ></path>
            <path
              id="Path_2"
              data-name="Path 2"
              d="M88.9,76.69h4.29a.664.664,0,0,1,.649.323.632.632,0,0,1-.458.927,1.262,1.262,0,0,1-.206.008H84.559c-.42,0-.687-.2-.731-.535a.6.6,0,0,1,.6-.715c.5-.015,1.006-.006,1.509-.007Z"
              transform="translate(-31.314 -4.358)"
              fill="#ffffff"
            ></path>
            <path
              id="Path_3"
              data-name="Path 3"
              d="M86.639,119.967H84.571c-.483,0-.75-.237-.743-.641.007-.383.284-.615.743-.616h4.2a.65.65,0,0,1,.737.63c0,.377-.288.625-.737.627C88.057,119.969,87.348,119.967,86.639,119.967Z"
              transform="translate(-31.319 -43.225)"
              fill="#ffffff"
            ></path>
            <path
              id="Path_4"
              data-name="Path 4"
              d="M85.659,161.946c-.383,0-.768.006-1.152,0a.638.638,0,1,1,0-1.271q1.182-.011,2.364,0a.65.65,0,0,1,.72.622.66.66,0,0,1-.722.65C86.467,161.952,86.063,161.946,85.659,161.946Z"
              transform="translate(-31.303 -82.036)"
              fill="#ffffff"
            ></path>
            <path
              id="Path_5"
              data-name="Path 5"
              d="M397.749,235.777a.612.612,0,0,1,.616-.618.627.627,0,0,1,.639.633.643.643,0,0,1-.624.624.628.628,0,0,1-.631-.639Z"
              transform="translate(-321.684 -150.935)"
              fill="#ffffff"
            ></path>
          </g>
        </svg>
      );
    } else if (sportId == "4339") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27.762"
          height="26.721"
          viewBox="0 0 27.762 26.721"
        >
          <g id="Greyhound-01" transform="translate(-50.076 -57.509)">
            <path
              id="Path_1"
              data-name="Path 1"
              d="M77.824,63.982a.578.578,0,0,0-.056.083,1.541,1.541,0,0,1-2.04,1.069c-.763-.222-1.513-.479-2.276-.7-.389-.111-.472.16-.666.34s-.083.312,0,.472a6.3,6.3,0,0,1-1.221,7.382,2.857,2.857,0,0,0-.812,1.575,27.416,27.416,0,0,1-1.173,4.746,6.71,6.71,0,0,1-1.145,2.068,3.117,3.117,0,0,1-1.145.888.584.584,0,0,0-.305.312,3.361,3.361,0,0,1-2.574,1.977,3.272,3.272,0,0,1-3.393-1.776,1.414,1.414,0,0,0-.618-.624,4.134,4.134,0,0,1-1.658-1.839,15.623,15.623,0,0,1-1.3-3.913c-.194-.86-.368-1.728-.541-2.595a.879.879,0,0,0-.278-.5,6.7,6.7,0,0,1-2.186-4.288,6.012,6.012,0,0,1,.687-3.448.388.388,0,0,0-.049-.472.589.589,0,0,0-.791-.257c-.7.236-1.408.437-2.116.659a1.506,1.506,0,0,1-1.7-.423,1.532,1.532,0,0,1-.229-1.742,8.923,8.923,0,0,1,6.55-5.336,3.539,3.539,0,0,1,2.331.139,3.294,3.294,0,0,1,1.513,1.388,10.945,10.945,0,0,1,.722,1.422.214.214,0,0,0,.284.153,11.667,11.667,0,0,1,4.6,0c.173.035.25-.014.319-.18a10.566,10.566,0,0,1,.715-1.395,3.207,3.207,0,0,1,3.58-1.568,9.138,9.138,0,0,1,5.377,3.046A8.437,8.437,0,0,1,77.8,63.379c.007.014.028.021.042.028ZM64.773,79.975a1.545,1.545,0,0,0,2.366.056,3.423,3.423,0,0,0,.451-.638,9.546,9.546,0,0,0,.8-2.033c.444-1.52.673-3.081,1.02-4.621a1.142,1.142,0,0,1,.409-.673,5.633,5.633,0,0,0,1.152-1.249,4.533,4.533,0,0,0,.569-4.371,6.1,6.1,0,0,0-3.032-3.212,9.706,9.706,0,0,0-6.279-.957,8.3,8.3,0,0,0-4.42,2.068,5.013,5.013,0,0,0-1.776,3.726A4.865,4.865,0,0,0,57.779,71.8a2.175,2.175,0,0,1,.7,1.256,44,44,0,0,0,1.075,4.635,6.552,6.552,0,0,0,1.1,2.241A1.555,1.555,0,0,0,63.107,80c-.062-.09-.16-.111-.243-.16A5.419,5.419,0,0,1,62,79.33a2.179,2.179,0,0,1,.951-3.879,9.268,9.268,0,0,1,1.7-.035,1.839,1.839,0,0,1,.93.257A2.123,2.123,0,0,1,66.743,77.6a2.181,2.181,0,0,1-1.166,1.943C65.321,79.691,65.043,79.823,64.773,79.975ZM76.131,63.552a7.8,7.8,0,0,0-1.422-2.193,7.722,7.722,0,0,0-4.3-2.213,1.534,1.534,0,0,0-1.672.729,10.434,10.434,0,0,0-.624,1.166c-.076.153-.021.2.111.25a9.217,9.217,0,0,1,3.317,2.186c.1.1.153.1.243-.014a1.615,1.615,0,0,1,1.131-.715,2.542,2.542,0,0,1,.937.118C74.6,63.046,75.326,63.323,76.131,63.552Zm-24.361,0c.125-.035.208-.062.291-.083.666-.2,1.311-.444,1.991-.6a2.5,2.5,0,0,1,.985-.111,1.807,1.807,0,0,1,1.18.819c.021-.007.028-.007.035-.014a9.615,9.615,0,0,1,3.469-2.29c.146-.056.118-.125.069-.222-.146-.284-.284-.583-.444-.867a1.667,1.667,0,0,0-2.165-.978,7.505,7.505,0,0,0-4.149,2.324,7.371,7.371,0,0,0-1.263,2.019ZM63.954,77.04c-.215,0-.43-.007-.652,0a.533.533,0,0,0-.507.382.459.459,0,0,0,.146.562,4.854,4.854,0,0,0,.957.555.118.118,0,0,0,.1,0A5.439,5.439,0,0,0,64.932,78a.486.486,0,0,0,.16-.583.535.535,0,0,0-.507-.375C64.37,77.033,64.162,77.033,63.954,77.04ZM62.767,82.05a1.523,1.523,0,0,0,2.359,0,3.487,3.487,0,0,1-1.075-.541.132.132,0,0,0-.187-.014A3.479,3.479,0,0,1,62.767,82.05Z"
              fill="#ffffff"
            ></path>
            <path
              id="Path_2"
              data-name="Path 2"
              d="M185.312,210.8a.805.805,0,0,1,.812.8v.007a.825.825,0,0,1-.812.826H185.3a.831.831,0,0,1-.8-.819A.817.817,0,0,1,185.312,210.8Z"
              transform="translate(-125.098 -142.653)"
              fill="#ffffff"
            ></path>
            <path
              id="Path_3"
              data-name="Path 3"
              d="M292,211.6a.8.8,0,0,1,.8-.8h.007a.816.816,0,0,1,.819.8.841.841,0,0,1-.826.826A.816.816,0,0,1,292,211.6Z"
              transform="translate(-225.139 -142.655)"
              fill="#ffffff"
            ></path>
          </g>
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M23.4267 4.57333C20.912 2.14456 17.544 0.80063 14.048 0.831009C10.5521 0.861388 7.20792 2.26364 4.73581 4.73575C2.2637 7.20786 0.861449 10.552 0.83107 14.048C0.800692 17.5439 2.14462 20.912 4.57339 23.4267C7.08809 25.8554 10.4561 27.1994 13.9521 27.169C17.448 27.1386 20.7922 25.7364 23.2643 23.2642C25.7364 20.7921 27.1387 17.448 27.169 13.952C27.1994 10.4561 25.8555 7.08803 23.4267 4.57333ZM6.45339 6.45333C7.95564 4.95046 9.87253 3.93052 11.9583 3.5243C14.044 3.11807 16.2036 3.34408 18.1601 4.17333L17.7734 4.57333L18.7201 5.52L19.4134 4.81333C19.8 5.04659 20.1738 5.30028 20.5334 5.57333L5.57339 20.5333C5.30034 20.1738 5.04665 19.7999 4.81339 19.4133L5.52006 18.72L4.57339 17.7733L4.18672 18.16C3.35581 16.2048 3.12765 14.046 3.53148 11.9604C3.93532 9.87467 4.95275 7.95708 6.45339 6.45333ZM21.5467 21.5467C20.0445 23.0495 18.1276 24.0695 16.0418 24.4757C13.9561 24.8819 11.7965 24.6559 9.84006 23.8267L10.2267 23.4267L9.28006 22.48L8.58672 23.1867C8.20015 22.9534 7.82629 22.6997 7.46672 22.4267L22.4267 7.46666C22.6998 7.82623 22.9535 8.20009 23.1867 8.58666L22.4801 9.28L23.4267 10.2267L23.8134 9.84C24.6443 11.7952 24.8725 13.9539 24.4686 16.0396C24.0648 18.1253 23.0474 20.0429 21.5467 21.5467ZM13.0534 18.72L14.0001 19.6533L12.1201 21.5467L11.1734 20.6667L13.0534 18.72ZM16.8267 14.9467L17.7734 15.88L15.8801 17.7733L14.9467 16.8267L16.8267 14.9467ZM20.6667 11.1733L21.6134 12.12L19.6534 14L18.7201 13.0533L20.6667 11.1733ZM14.9467 9.28L14.0001 8.34666L15.8801 6.45333L16.8267 7.4L14.9467 9.28ZM11.1734 13.0533L10.2267 12.12L12.1201 10.2267L13.0534 11.1733L11.1734 13.0533ZM7.40006 16.8267L6.45339 15.88L8.34672 14L9.28006 14.9467L7.40006 16.8267Z"
            fill="#ffffff"
          ></path>
        </svg>
      );
    }
  };

  return featureEvent?.featureVenetData?.length > 0 ? (
    <Slider {...settings} className="live-match-btns">
      {featureEvent &&
        featureEvent.featureVenetData.map((gameItem, index) => (
          <button
            onClick={() => navigate(`/exchange_inPlay/${gameItem.eventId}`)}
            className="btn blink"
            key={gameItem.eventId}
          >
            {getIcon(gameItem.sportId)}
            <span className="slider-eventname">{gameItem.eventName}</span>
          </button>
        ))}
    </Slider>
  ) : (
    ""
  );
}
